import type { EventTimeline } from '../core/Timelines';
import { isLoadEventTimeData } from '../core/TimeData';

export type LoadedAmount = {
  orderId: number;
  loadedVolume: number;
  loadedMass: number;
  loadedPcs: number;
  cargoAmount: number;
  cargoUnit: string | null;
};

export const getTimelineLoadedAmounts: (
  timeline: EventTimeline,
  focusedOrderIds?: Set<number>,
) => LoadedAmount[] = (timeline, focusedOrderIds) => {
  const loadTds = timeline.voyageGroups
    .flatMap((vg) => vg.events)
    .filter(isLoadEventTimeData);
  return (
    focusedOrderIds
      ? loadTds.filter((td) => focusedOrderIds.has(td.event.order.id))
      : loadTds
  ).map((td) => {
    return {
      orderId: td.event.order.id,
      loadedVolume: td.volume,
      loadedMass: td.mass,
      loadedPcs: td.pcs,
      cargoAmount: Number(td.event.order.cargoAmount),
      cargoUnit: td.event.order.cargoUnitByCargoUnitId?.name || null,
    };
  });
};
